import clsx from 'clsx';

interface ILoadingTextProps {
  className?: string;
  /**
   * Just a dummy text to be used for SEO and for getting a decently sized
   * content for the skeleton ans serves as self documentation. Hidden from the user.
   */
  text?: string;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a fallback text component that is dipslayed when the actual
 * text content to be displayed is being loaded.
 */
export function LoadingText({ className, text }: ILoadingTextProps) {
  return (
    <div
      className={clsx(
        `
          before:animate-shimmer relative w-fit truncate rounded-xl bg-gray-100
          bg-gradient-to-r from-gray-200/50 text-start !text-transparent before:absolute
          before:inset-0 before:-translate-x-full before:rounded-2xl before:bg-gradient-to-r
          before:from-gray-200/40 before:via-gray-300/20 before:to-transparent
          rtl:bg-gradient-to-l before:rtl:-translate-x-full before:rtl:bg-gradient-to-l
        `,
        className
      )}
      title={text}
    >
      {text}
    </div>
  );
}
